import { type ClassValue, clsx } from 'clsx'
import {
	ConfigExtension,
	DefaultClassGroupIds,
	DefaultThemeGroupIds,
	extendTailwindMerge,
} from 'tailwind-merge'

import { theme } from '@/theme'

const colors = theme.colors
const colorValues = Object.keys(colors)
const colorClasses = Object.keys(colors).map((value) => `text-${value}`)

const borderRadiusValues = Object.keys(theme.borderRadius)

const fontSizeClasses = Object.keys(theme.fontSize).map(
	(value) => `text-${value}`,
)
const typeClasses = Object.keys(theme.type).map((value) => `type-${value}`)

type CustomClassGroupIds = DefaultClassGroupIds | 'type'

export const extendTailwindMergeOptions = {
	extend: {
		theme: {
			colors: colorValues,
			borderRadius: borderRadiusValues,
		},
		classGroups: {
			'text-color': colorClasses,
			'font-size': fontSizeClasses,
			type: typeClasses,
		},
	},
} satisfies ConfigExtension<CustomClassGroupIds, DefaultThemeGroupIds>

const customTwMerge = extendTailwindMerge(extendTailwindMergeOptions)

export const cn = (...inputs: ClassValue[]) => customTwMerge(clsx(inputs))
